import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import PageHeader from "../../../components/Common/PageHeader";
import TableFilterDynamique from "components/Common/TableFilter/TableFilterDynamique";
import AddEditFeeModal from "../modals/AddEditFeeModal";
import StudentFeesTable from "../table/StudentFeesTable";
import useFee from "../hooks/useFee";
import { FilterField } from "../../../components/Common/TableFilter/TableFilter";
import { CLASS_SECTION_OPTIONS } from "../../../constants/classConstants";
import { all_routes } from "router/all_routes";
import CustomButton from "components/Common/ui/CustomButton";
import { formatToSQLDate } from "utils/dateUtils";
import dayjs from "dayjs";
import { useAbility } from "config/abilityContext";

const FinanceFees = () => {
  const { t } = useTranslation();
  const ability = useAbility();
  const {
    fees,
    infoPagination,
    loading,
    error,
    selectedFee,
    setSelectedFee,
    isModalOpen,
    setIsModalOpen,
    fetchFees,
    handleCreate,
    handleDelete,
    fetchStudents,
    fetchFeeTypes,
    students,
    feeTypes,
    statusFee
  } = useFee();

  const breadcrumbItems = [
    { label: "finance_dashboard", path: all_routes.financeDashboard },
    { label: "fees", active: true },
  ];


  const [filters, setFilters] = useState<{ [key: string]: string | number | null }>(() => {
    const start = formatToSQLDate(dayjs().startOf("month"));
    const end = formatToSQLDate(dayjs().endOf("month"));
    return { dueDateStart: start, dueDateEnd: end };
  });

  useEffect(() => {
    handleFilter(filters);
    fetchStudents();
    fetchFeeTypes();
  }, []);

  const filterFields: FilterField[] = [
    { key: "search", label: t("search"), type: "text" },
    {
      key: "studentId",
      label: t("student_name"),
      type: "select",
      options: students.map(student => ({
        label: `${student.user.firstName} ${student.user.lastName}`,
        value: student.id
      }))
    },
    {
      key: "feeTypeId",
      label: t("fee_type"),
      type: "select",
      options: feeTypes.map(feeType => ({
        label: feeType.name,
        value: feeType.id
      }))
    },
    {
      key: "status",
      label: t("status"),
      type: "select",
      options: statusFee
    },
    {
      key: "dueDate",
      label: t("due_date"),
      type: "range",
      rangeKeys: { start: "dueDateStart", end: "dueDateEnd" },
    }
  ];

  const handleSaveFee = async (feeData: any) => {
    let result = false;
    if (selectedFee) {
    } else {
      result = await handleCreate(feeData);
    }
    if (result) {
      setIsModalOpen(false);
      RefreshData();
    }
  };
 

  const handleEdit = (record: any) => {
    setSelectedFee(record);
    setIsModalOpen(true);
  };

  const handleFilter = (newFilters: {
    [key: string]: string | number | null;
  }) => {
    setFilters(newFilters);
    fetchFees({
      page: infoPagination.page || 1,
      limit: infoPagination.limit || 10, ...newFilters
    });
  };

  const RefreshData = () => {
    fetchFees({
      page: infoPagination.page || 1,
      limit: infoPagination.limit || 10, ...filters
    });
  };

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <PageHeader
          title={t("fees")}
          breadcrumbItems={breadcrumbItems}
        />
        <div className="d-flex mb-3 justify-content-end gap-2">
          {ability.can("create", "Fee") && (
            <CustomButton
              onClick={() => {
                setSelectedFee(null);
                setIsModalOpen(true);
              }}
            >
              <i className="ti ti-plus me-2" />
              {t("add_fees")}
            </CustomButton>
          )}
          <TableFilterDynamique
            fields={filterFields}
            filters={filters}
            onApply={(newFilters) => handleFilter(newFilters)}
            onReset={() => {
              setFilters({});
              fetchFees({ page: 1, limit: 10 });
            }}
          />
        </div>

        <StudentFeesTable
          dataSource={fees}
          onEdit={handleEdit}
          onDelete={handleDelete}
          loading={loading}
          dataPaginate={{
            current: infoPagination?.page || 1,
            pageSize: infoPagination?.limit || 10,
            total: infoPagination?.total,
          }}
          onChange={(pg) => {
            const params = {
              ...filters,
              page: pg.current || 1,
              limit: pg.pageSize || 10,
            };

            fetchFees(params);
          }}
        />

        <AddEditFeeModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onSave={handleSaveFee}
          students={students}
          feeTypes={feeTypes}
          selectedStudent={""}
        />
      </div>
    </div>
  );
};

export default FinanceFees;
